// The Reports tab on a finished event lists the safety reports filed at it.
//
// Reports used to be read off the event doc's `reports` array. That array was
// readable by every member, so reports now live only in the arbitrations
// collection (one case per report, written by the server) and the server removes
// them from the event doc. Until every old entry has been moved, an event can
// still carry some, so the tab shows both, once each.

// Same key the server uses to turn a report into a case id
// (gist-firebase-functions src/admin/arbitration.js reportSignature). Old PWA
// session reports name the reported member reportUserID / reportName; the server
// reads those as the same fields, and so does this.
function reportSignature(r) {
  return `${r?.reportedByUserID || ""}|${r?.reportedUserID || r?.reportUserID || ""}|${r?.note || ""}`;
}

function normalizeLegacy(r) {
  return {
    reportedUserID: r.reportedUserID || r.reportUserID || null,
    reportedName: r.reportedName || r.reportName || null,
    reportedByUserID: r.reportedByUserID || null,
    reportedByName: r.reportedByName || null,
    note: r.note || "",
  };
}

function createdMillis(c) {
  const t = c?.createdAt;
  if (t && typeof t.toMillis === "function") return t.toMillis();
  if (t && typeof t.seconds === "number") return t.seconds * 1000;
  return 0;
}

/**
 * Arbitration cases for one event plus any report still on the event doc that
 * has no case yet, in the shape the Reports tab reads (reportedName,
 * reportedUserID, reportedByName, reportedByUserID, note). Oldest first, like the
 * array was.
 */
export function mergeEventReports(cases, legacyReports) {
  const fromCases = (Array.isArray(cases) ? cases : [])
    .slice()
    .sort((a, b) => createdMillis(a) - createdMillis(b))
    .map((c) => ({
      reportedUserID: c.reportedUserID || null,
      reportedName: c.reportedName || null,
      reportedByUserID: c.reportedByUserID || null,
      reportedByName: c.reportedByName || null,
      note: c.note || "",
      caseId: c.id || null,
    }));
  const seen = new Set(fromCases.map(reportSignature));
  const leftovers = (Array.isArray(legacyReports) ? legacyReports : [])
    .filter((r) => r && typeof r === "object" && !seen.has(reportSignature(r)))
    .map(normalizeLegacy);
  return [...fromCases, ...leftovers];
}
